import { render } from "./izquierda.vue?vue&type=template&id=236538ca&scoped=true"
import script from "./izquierda.vue?vue&type=script&lang=js"
export * from "./izquierda.vue?vue&type=script&lang=js"

import "./izquierda.vue?vue&type=style&index=0&id=236538ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236538ca"]])

export default __exports__